import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import RedMarker from "../../Assets/Icons/RedMarker.png";
import {
  formatLatLng,
  formatLocation,
  formatPhoneNumber,
  viewSizeCalculator,
} from "../../utils";
import {
  AddressWrapper,
  AnchorWrapper,
  DetailsWrapper,
  MapParentWrapper,
  MapPlaceholder,
  PopupFooter,
  Title,
  Value,
  ViewAllButtonWrapper,
  Wrapper,
} from "./index.styled";
import { ReactComponent as Location } from "../../Assets/Icons/Location.svg";
import { ReactComponent as MapMarker } from "../../Assets/Icons/MapMarker.svg";
import { ReactComponent as Call } from "../../Assets/Icons/Call.svg";
import { ReactComponent as Website } from "../../Assets/Icons/Website.svg";

import { AnchorValue } from "../FactSheetLeft/index.styled";

const customIcon = new L.Icon({
  iconUrl: RedMarker,
  iconSize: [40, 40],
  iconAnchor: [15, 45],
  popupAnchor: [0, -40],
});

const MapComponent = ({ data, latitude, longitude, zoom = 13 }) => {
  const toTitleCase = (str) => {
    if (!str) return "";
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };
  let cleanUrl = data?.facilities?.website?.replace("http://localhost:3000/hospitals/", "");
  cleanUrl = cleanUrl && cleanUrl.replace(/^https?:\/\//, "");
  return (
    <MapParentWrapper>
      {!latitude || !longitude ? (
        <MapPlaceholder>No location available</MapPlaceholder>
      ) : (
        <MapContainer
          center={[latitude, longitude]}
          zoom={zoom}
          zoomControl={false}
          scrollWheelZoom={true}
          touchZoom={true}
          style={{
            height: viewSizeCalculator(15.375),
            width: "100%",
            borderRadius: viewSizeCalculator(0.75),
          }}
          attributionControl={false}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[latitude, longitude]} icon={customIcon}>
            <Popup>{toTitleCase(data?.name) || data?.name}</Popup>
          </Marker>
        </MapContainer>
      )}
      <Wrapper>
        <AddressWrapper>
          <Title>Hospital Location & Contact</Title>
          <DetailsWrapper>
            <Location />
            <Value>{formatLocation(data?.location)}</Value>
          </DetailsWrapper>

          {/* <DetailsWrapper>
            <MapMarker />
            <Value>{formatLatLng(latitude, longitude)}</Value>
          </DetailsWrapper> */}

          <DetailsWrapper>
            <MapMarker />
            <Value>{`${data?.street_addr}, ${data?.zip_code || "-"}`}</Value>
          </DetailsWrapper>

          <DetailsWrapper>
            <Call />
            <Value>{formatPhoneNumber(data?.facilities?.contact) || "-"}</Value>
          </DetailsWrapper>
          {/* <DetailsWrapper> */}
          {/* <ZipIcon /> */}
          {/* <img src={ZipIcon} alt="" srcset="" /> */}
          {/* <Value>{data?.zip_code ?? "-"}</Value> */}
          {/* </DetailsWrapper> */}
          <DetailsWrapper>
            <Website />
            {data?.facilities?.website ? <Value
              title={data?.facilities?.website}
              style={{ textTransform: "none" }}
              href={`https://${cleanUrl}`}
            >
              <AnchorWrapper>
                <AnchorValue
                  href={`https://${cleanUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cleanUrl}
                </AnchorValue>
              </AnchorWrapper>
            </Value> : "-"}
          </DetailsWrapper>
        </AddressWrapper>

        {/* <PartnersWrapper>
          <PartnerTitle>Nearby Partners</PartnerTitle>
          --/-- */}
        {/* <Partner>
            <Value>St. Anne Hospital</Value>
            <ValueBold>11 M</ValueBold>
          </Partner>
          <Partner>
            <Value>St. Francis Hospital</Value>
            <ValueBold>11 M</ValueBold>
          </Partner>
          <Partner>
            <Value>St. Joseph Medical Hospital</Value>
            <ValueBold>11 M</ValueBold>
          </Partner>
          <Partner>
            <Value>St. Anthony Hospital</Value>
            <ValueBold>11 M</ValueBold>
          </Partner> */}
        {/* </PartnersWrapper> */}
      </Wrapper>
      <PopupFooter>
        <ViewAllButtonWrapper>
          {/* <ViewAllContent>View More in Maps</ViewAllContent> */}
          {/* <PlayButtonWrapper>
            <PlayButton />
          </PlayButtonWrapper> */}
        </ViewAllButtonWrapper>
      </PopupFooter>
    </MapParentWrapper>
  );
};

export default MapComponent;
